(function () {
  function slugify(value, index) {
    var slug = value
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'policy-section-' + (index + 1);
  }

  function escapeHtml(value) {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function formatNumberedHeading(heading) {
    if (heading.querySelector('.policy-page__heading-number')) return;

    var text = heading.textContent.trim();
    var match = text.match(/^(\d+\.)\s+(.+)$/);

    if (!match) return;

    heading.classList.add('policy-page__heading-numbered');
    heading.innerHTML =
      '<span class="policy-page__heading-number">' + escapeHtml(match[1]) + '</span>' +
      '<span class="policy-page__heading-text">' + escapeHtml(match[2]) + '</span>';
  }

  function setNavLabel(link, label) {
    var match = label.match(/^(\d+\.)\s*(.+)$/);

    if (!match) {
      link.textContent = label;
      return;
    }

    link.classList.add('policy-page__toc-link--numbered');
    link.innerHTML =
      '<span class="policy-page__toc-number">' + escapeHtml(match[1]) + '</span>' +
      '<span class="policy-page__toc-text">' + escapeHtml(match[2]) + '</span>';
  }

  function transformShortcodes(content) {
    var html = content.innerHTML;

    html = html
      .replace(/<pre\b[^>]*>\s*<code\b[^>]*>\s*\[(policy-box|policy-callout|callout)\]\s*(?:<br\s*\/?>)?([\s\S]*?)(?:<br\s*\/?>)?\s*\[\/\1\]\s*<\/code>\s*<\/pre>/gi, '[$1]$2[/$1]')
      .replace(/<pre\b[^>]*>\s*\[(policy-box|policy-callout|callout)\]\s*(?:<br\s*\/?>)?([\s\S]*?)(?:<br\s*\/?>)?\s*\[\/\1\]\s*<\/pre>/gi, '[$1]$2[/$1]')
      .replace(/<code\b[^>]*>\s*\[(policy-box|policy-callout|callout)\]\s*(?:<br\s*\/?>)?([\s\S]*?)(?:<br\s*\/?>)?\s*\[\/\1\]\s*<\/code>/gi, '[$1]$2[/$1]')
      .replace(/<p>\s*\[(policy-box|policy-callout|callout)\]\s*<\/p>/gi, '[$1]')
      .replace(/<p>\s*\[\/(policy-box|policy-callout|callout)\]\s*<\/p>/gi, '[/$1]')
      .replace(/<p>\s*\[(policy-box|policy-callout|callout)\]\s*(?:<br\s*\/?>)?/gi, '[$1]')
      .replace(/(?:<br\s*\/?>)?\s*\[\/(policy-box|policy-callout|callout)\]\s*<\/p>/gi, '[/$1]');

    html = html.replace(/\[(policy-box|policy-callout|callout)\]([\s\S]*?)\[\/\1\]/gi, function (_match, _type, inner) {
      var calloutContent = inner
        .trim()
        .replace(/^(?:<br\s*\/?>|&nbsp;|\s)+/gi, '')
        .replace(/(?:<br\s*\/?>|&nbsp;|\s)+$/gi, '');

      if (!/^<(p|ul|ol|blockquote|div|h[1-6])[\s>]/i.test(calloutContent)) {
        calloutContent = '<p>' + calloutContent + '</p>';
      }

      return '<div class="policy-page__callout"><div class="policy-page__callout-content">' + calloutContent + '</div></div>';
    });

    content.innerHTML = html;

    Array.prototype.slice.call(content.querySelectorAll('.policy-page__callout')).forEach(function (callout) {
      var wrapper = callout.parentElement;

      while (wrapper && wrapper !== content && /^(code|pre)$/i.test(wrapper.tagName)) {
        var parent = wrapper.parentNode;
        parent.insertBefore(callout, wrapper);

        if (!wrapper.textContent.trim() && !wrapper.querySelector('img, iframe, video, svg')) {
          wrapper.remove();
        }

        wrapper = callout.parentElement;
      }
    });

    Array.prototype.slice.call(content.querySelectorAll('pre, code')).forEach(function (node) {
      if (!node.textContent.trim() && !node.querySelector('img, iframe, video, svg')) node.remove();
    });
  }

  function buildPolicyPage(root) {
    var content = root.querySelector('[data-policy-content]');
    var desktopNav = root.querySelector('[data-policy-toc]');
    var mobileNav = root.querySelector('[data-policy-mobile-menu]');
    var mobileCurrent = root.querySelector('[data-policy-mobile-current]');
    var mobileDetails = root.querySelector('[data-policy-mobile-toc]');

    if (!content || !desktopNav || !mobileNav) return;

    transformShortcodes(content);

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));

    if (!headings.length) {
      if (root.querySelector('.policy-page__rail')) {
        root.querySelector('.policy-page__rail').setAttribute('hidden', '');
      }
      if (root.querySelector('.policy-page__mobile-toc-wrap')) {
        root.querySelector('.policy-page__mobile-toc-wrap').setAttribute('hidden', '');
      }
      return;
    }

    headings.forEach(formatNumberedHeading);

    var usedIds = {};

    headings.forEach(function (heading, index) {
      var label = heading.textContent.trim();
      var id = heading.id || slugify(label, index);
      var uniqueId = id;
      var suffix = 2;

      while (usedIds[uniqueId]) {
        uniqueId = id + '-' + suffix;
        suffix += 1;
      }

      usedIds[uniqueId] = true;
      heading.id = uniqueId;

      var desktopLink = document.createElement('a');
      desktopLink.className = 'policy-page__toc-link';
      desktopLink.href = '#' + uniqueId;
      setNavLabel(desktopLink, label);
      desktopNav.appendChild(desktopLink);

      var mobileLink = document.createElement('a');
      mobileLink.className = 'policy-page__mobile-toc-link';
      mobileLink.href = '#' + uniqueId;
      setNavLabel(mobileLink, label);
      mobileNav.appendChild(mobileLink);

      if (index === 0 && mobileCurrent) {
        mobileCurrent.textContent = label;
      }
    });

    var links = Array.prototype.slice.call(root.querySelectorAll('.policy-page__toc-link, .policy-page__mobile-toc-link'));

    function setActive(id) {
      links.forEach(function (link) {
        var isActive = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', isActive);
      });

      var activeHeading = headings.find(function (heading) {
        return heading.id === id;
      });

      if (activeHeading && mobileCurrent) {
        mobileCurrent.textContent = activeHeading.textContent.trim();
      }
    }

    links.forEach(function (link) {
      link.addEventListener('click', function () {
        if (mobileDetails) mobileDetails.removeAttribute('open');
      });
    });

    setActive(headings[0].id);

    var scrollTicking = false;

    function updateActiveOnScroll() {
      var offset = window.matchMedia('(max-width: 989px)').matches ? 120 : 140;
      var activeId = headings[0].id;

      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= offset) {
          activeId = heading.id;
        }
      });

      setActive(activeId);
      scrollTicking = false;
    }

    function requestActiveUpdate() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateActiveOnScroll);
    }

    window.addEventListener('scroll', requestActiveUpdate, { passive: true });
    window.addEventListener('resize', requestActiveUpdate);
    updateActiveOnScroll();
  }

  function initPolicyPages() {
    Array.prototype.slice.call(document.querySelectorAll('[data-policy-page]')).forEach(buildPolicyPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPolicyPages);
  } else {
    initPolicyPages();
  }
})();
